








import { Component, Vue } from 'vue-property-decorator';

import $ from 'jquery';

import Authentification from '@/components/desktop/Authentification.vue';
import Kernel from '@/components/desktop/Kernel.vue';
import MobileGesture from '@/components/mobile/MobileGesture.vue';
import { isIOS, mobileAndTabletcheck } from './scripts/utils/Utils';

// State of the screen
enum STARTSTATE {
  KERNEL = 'KERNEL',
  AUTHENTIFICATION = 'AUTHENTIFICATION',
  MOBILE = 'MOBILE',
}

@Component({
  components: {
    Kernel,
    Authentification,
    MobileGesture,
  },
})
export default class App extends Vue {
  private animation: boolean = true;

  private currentState: string = STARTSTATE.AUTHENTIFICATION;

  private checkStr(str: string) {

  }

  public mounted() {
    $('.container-fluid').attr('padding', 0);
    // Check mobile device
    if (mobileAndTabletcheck()) {
      this.currentState = STARTSTATE.MOBILE;
      if (isIOS()) {
        $('body').toggleClass('ios-boot');
      } else {
        $('body').toggleClass('android-boot');
      }
      console.log('Mobile detected !');
    } else {
      $('body').toggleClass('window-boot');
    }

    setTimeout(() => {
      $('body').css({ 'background-color': 'black' });
      $('body').css('background-image', 'none');
      this.$root.$emit('App::Animation::End');
    }, 2000);

    this.$root.$on('TypeWritter::Animation::End', () => {
      this.animation = false;
      this.currentState = STARTSTATE.KERNEL;
      $('body').removeAttr('style');
      $('body').addClass('wallpaper-bg');
      $('#app').css({ 'background-color': 'transparent' });
    });
  }
}
